import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	dateOfAgreement: "",
	companyName: "",
	daysOfAgreement: "",
	signingAuthorityName: "",
	officialAddress: "",
	designation: "",
	emailAddress: "",
	technicalName: "",
	technicalDesignation: "",
	technicalEmail: "",
	technicalPhoneNumber: "",
	billingName: "",
	billingDesignation: "",
	billingEmail: "",
	billingPhoneNumber: "",
	commercialName: "",
	commercialDesignation: "",
	commercialEmail: "",
	commercialPhoneNumber: "",
	currency: "USD",
	partyA: null,
	partyB: null,
	milestones: [],
	paymentDueDate: "",
	licensingRegion: "",
	licensingCountry: [],
	carrierType: [],
	numberOfRefreshCycles: "",
	numberOfMonthsPerCycle: "",
	paymentStatus: "InProcess",
	paymentModel: "",
	paymentPlan: "",
	paymentTerm: "",
	amountPaid: 0,
	amountRemaining: 0,
	airline: [],
	paymentReceiptFilePath: "",
	agreementFilePath: "",
};

export const agreementFormSlice = createSlice({
	name: "agreementForm",
	initialState,
	reducers: {
		// Generic handler to update any property in the state
		setAgreementFormField: (state, action) => {
			const { field, value } = action.payload;
			if (state.hasOwnProperty(field)) {
				state[field] = value;
			}
		},
		setAgreementDetails: (state, action) => {
			const agreementDetails = action.payload;
			state = agreementDetails;
			return state;
		},
		resetAgreementForm: (state, action) => {
			state = initialState;
			return state;
		},
		// If you need to handle any specific property with custom logic, you can add more reducers here
	},
});

// Action creators are generated for each case reducer function
export const {
	setAgreementDetails,
	setAgreementFormField,
	resetAgreementForm,
} = agreementFormSlice.actions;

export default agreementFormSlice.reducer;
